import { render, staticRenderFns } from "./ManagedListsServerTable.vue?vue&type=template&id=61df7882"
import script from "./ManagedListsServerTable.vue?vue&type=script&lang=js"
export * from "./ManagedListsServerTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports